import React from "react";
import "./Cover.css";

const Cover = () => {
  return (
    <section className="cover">
      <a
        href="https://stampsy.com/na-elektrichkakh-do-baikala"
        className="cover__link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="cover__overlay"></div>
        <div className="cover__content">
          <h2 className="cover__title">До Байкала «на собаках»</h2>
          <h3 className="cover__subtitle">
            По мотивам учебной темы о Транссибе — путешествие от столицы до
            Байкала на электричках.
          </h3>
        </div>
      </a>
    </section>
  );
};

export default Cover;
